"use-strict";

import 'jquery';

export class Alert{
    constructor(){}
}
